import useService from 'hooks/services/useService';
import sessionService from 'services/AuthService/Login/sessionService';

const useIsAdmin = () => useService(sessionService.isAdmin);

export default useIsAdmin;
